const urlParams = new URLSearchParams(window.location.search);
const pixelID = urlParams.get("pixel");

if (pixelID) {
  document.addEventListener("DOMContentLoaded", function () {
    // console.log(pixelID);
    // Якщо параметр пікселя існує
    // Ініціалізуємо Facebook Pixel з отриманим ID
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js",
    );

    fbq("init", pixelID); // Використовуємо піксель з URL
    fbq("track", "Lead"); // Відстеження події Lead

    // Вставляємо піксель у no-script fallback
    var img = document.createElement("img");
    img.height = 1;
    img.width = 1;
    img.style.display = "none";
    img.src =
      "https://www.facebook.com/tr?id=" + pixelID + "&ev=PageView&noscript=1";
    document.body.appendChild(img);
  });

  document.addEventListener("click", function () {
    fbq("track", "ClickEvent");
  });
}
